import { render } from "./covid-risk.vue?vue&type=template&id=0b6d0855&scoped=true"
import script from "./covid-risk.vue?vue&type=script&lang=js"
export * from "./covid-risk.vue?vue&type=script&lang=js"

import "./covid-risk.vue?vue&type=style&index=0&id=0b6d0855&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6d0855"]])

export default __exports__